module.exports = __webpack_public_path__ + "img/206-Brun Marron.jpg";